import { isNil, keyBy } from 'lodash';
import Query from '../Query';
import { Tree } from '../lib/Tree';
import Project from './Project';

export class ProjectTree extends Tree<Project> {
  static async load(query: Query<any, Project>) {
    const projects = await (query || new Query(Project))
      .select('id', 'name')
      .merge({
        parent: ['id', 'name'],
      })
      .per(100)
      .findInBatches();
    return new ProjectTree(projects);
  }

  projectsById: Record<string, Project>;

  constructor(projects: Project[]) {
    const projectsById = keyBy(projects, 'id');
    const projectParent = (project: Project) =>
      projectsById[project.parent?.id];
    super(projects, project => projectParent(project));
    this.projectsById = projectsById;
  }

  /**
   * @param {string} id
   */
  findById(id: string) {
    return this.projectsById[id];
  }

  /**
   * Return a structure suitable for selectro
   */
  toSelectroOptions(filter: (project: Project) => boolean) {
    const options = this.rootNode.fold((item, children) => {
      if (children.length > 0 && children.every(isNil)) {
        // Return null for a product line with no visible products
        return null;
      }

      if (children.length > 0) {
        return {
          text: item.name,
          value: item.id,
          children: children.filter(Boolean),
        };
      } else {
        if (filter && !filter(item)) return null;
        return { text: item.name, value: item.id };
      }
    });

    return { children: options };
  }
}
